import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from './globals';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Permission } from 'app/models/permission';

@Injectable({ providedIn: 'root' })
export class PermissionService {

    constructor(private http: HttpClient, private globals: Globals, 
                private formBuilder: FormBuilder) {
    }

    formGroup(permission: Permission = null){
        let frmGrp: FormGroup = this.formBuilder.group({
            id: [(permission)? permission.id: null],
            name: [(permission)? permission.name: '', [Validators.required, Validators.maxLength(255)]],
            applies_to: [(permission)? permission.applies_to: '', []],
            target_teams: [(permission)? permission.target_teams: []],
            target_tags: [(permission)? permission.target_tags: []],
            target_workflow_names: [(permission)? permission.target_workflow_names: []],
            target_paths: [(permission)? permission.target_paths: []],
            index_patterns: [(permission && permission.index_patterns) || []],
            include_fields: [(permission && permission.include_fields) || []]
        });

        return frmGrp;
    }

    getDefaultPermissions() {
        return this.http.get<Permission[]>(`${this.globals.api_base_url}/policy/default_permissions`);
    }

    putDefaultPermissions(defaultPermissions: Permission[]) {
        return this.http.put<Permission[]>(`${this.globals.api_base_url}/policy/default_permissions`, { permissions: defaultPermissions });
    }
}